import { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import { Link } from "react-router-dom";

// ─── Data ────────────────────────────────────────────────────────────────────

const FAQ_ITEMS = [
  {
    question: "What is ShieldCrypt?",
    answer:
      "ShieldCrypt is a specialised service provider that offers a combination of technical expertise and legal resources to help individuals and businesses recover lost, stolen, or inaccessible cryptocurrencies and assets. Our team works diligently to trace and recover stolen assets from hacked wallets or scam activities, restore access to lost wallets, and recover funds that were sent to the wrong address.",
  },
  {
    question: "Is it possible to recover cryptocurrency lost or stolen due to a scam or fraud?",
    answer:
      "Yes, in many cases it is possible to recover cryptocurrency lost or stolen due to a scam or fraud. Our team has extensive experience in dealing with these types of situations and can help you navigate the process of recovering your assets. We will work with you to document the details of the scam or fraud and gather any necessary evidence to support your case.",
  },
  {
    question: "How long does it typically take to recover lost or stolen cryptocurrency?",
    answer:
      "The amount of time it takes to recover lost or stolen cryptocurrency can vary depending on the specific circumstances of your case, however, our team will be able to recover your assets within a few days. Rest assured that our team is committed to working tirelessly on your behalf to get your assets back as quickly as possible.",
  },
  {
    question: "Will my information and assets be kept confidential?",
    answer:
      "At ShieldCrypt, we understand the importance of privacy and security when it comes to assets. We take all necessary precautions to protect your personal and financial information, and our team is composed of experienced professionals who are dedicated to providing you with the highest level of service and support. Your information and assets will be kept strictly confidential throughout the recovery process.",
  },
];

// ─── Component ───────────────────────────────────────────────────────────────

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (i) => setActiveIndex(activeIndex === i ? null : i);

  return (
    <div className="bg-[#F7F3EC] px-8 py-28 border-b border-[#E0D9CC]">
      <div className="max-w-[760px] mx-auto">

        <p className="text-[0.72rem] font-semibold tracking-[0.16em] uppercase text-[#C4622D] mb-4">
          FAQ
        </p>
        <h1 className="sc-serif text-[clamp(1.8rem,3.5vw,2.75rem)] text-[#1C1A16] leading-[1.15] mb-3">
          Frequently asked questions about us
        </h1>
        <p className="text-[#6B6457] text-[0.9rem] mb-14">
          Can't find the question you're looking for?{" "}
          <Link to="/contact" className="text-[#C4622D] no-underline font-semibold hover:underline">
            Contact us
          </Link>
        </p>

        <div>
          {FAQ_ITEMS.map((item, i) => (
            <div
              key={i}
              className={`border-t border-[#E0D9CC] border-l-[3px] pl-4 transition-colors duration-200 ${activeIndex === i ? "border-l-[#C4622D]" : "border-l-transparent"
                }`}
            >
              <button
                onClick={() => toggle(i)}
                className="flex items-center justify-between w-full gap-6 py-6 text-left bg-transparent border-none cursor-pointer"
              >
                <span className="text-[#1C1A16] font-semibold text-[0.95rem] leading-snug">
                  {item.question}
                </span>
                <span className="text-[#C4622D] shrink-0">
                  {activeIndex === i ? <FaMinus size={11} /> : <FaPlus size={11} />}
                </span>
              </button>

              {activeIndex === i && (
                <p className="text-[#6B6457] text-[0.875rem] leading-[1.8] pb-6">
                  {item.answer}
                </p>
              )}
            </div>
          ))}
          <div className="border-t border-[#E0D9CC]" />
        </div>
      </div>
    </div>
  );
};

export default FAQ;